import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaRegWindowClose } from "react-icons/fa";
// import { motion } from "framer-motion";

const Header = () => {
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <div className="top-0 w-full sticky z-50">
      {/* Top Header */}
      <div className="flex justify-between items-center py-5 px-[8%] bg-slate-900">
        <Link to="home" className="text-[#00A9FF] text-xl font-bold">
          JMK
        </Link>

        {/* Desktop Menu */}
        <div className="lg:flex hidden gap-6">
          <Link className="text-[#00A9FF]" to="home">Home</Link>
          <Link className="text-[#00A9FF]" to="Skill">Skill</Link>
          <Link className="text-[#00A9FF]" to="Project">Project</Link>
          <Link className="text-[#00A9FF]" to="About">About</Link>
          <Link className="text-[#00A9FF]" to="blog">Blogs</Link>
          <Link className="text-[#00A9FF]" to="Contact">Contact</Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setOpenMenu(true)}
          className="lg:hidden p-2 rounded-full bg-white text-slate-900"
        >
          <FaBars className="h-6 w-6" />
        </button>
      </div>

      {/* Drawer Menu */}
      {openMenu && (
        <div className="fixed inset-0 bg-black/60 z-50" onClick={() => setOpenMenu(false)}>
          <div
            
            className="absolute right-0 top-0 h-full w-72 bg-gray-900 text-white shadow-lg p-6"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setOpenMenu(false)}
              className="absolute top-4 right-4 text-gray-700"
            >
              <FaRegWindowClose className="h-6 w-6" />
            </button>

            {/* Drawer Links */}
            <ul className="flex flex-col gap-4 mt-10 text-white text-lg">
              <Link onClick={() => setOpenMenu(false)} to="home">Home</Link>
              <Link onClick={() => setOpenMenu(false)} to="Skill">Skill</Link>
              <Link onClick={() => setOpenMenu(false)} to="Project">Project</Link>
              <Link onClick={() => setOpenMenu(false)} to="About">About</Link>
              <Link onClick={() => setOpenMenu(false)} to="blog">Blogs</Link>
              <Link onClick={() => setOpenMenu(false)} to="Contact">Contact</Link>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;